import type { RouteRecordRaw } from "vue-router";
import CampaignList from "@/views/CampaignList.vue";
import CampaignDetail from "@/views/CampaignDetail.vue";
import CampaignDashboard from "@/components/Campaign/CampaignDashboard.vue";
import CampaignClients from "@/components/Campaign/CampaignClients.vue";
import CampaignInstallers from "@/components/Campaign/CampaignInstallers.vue";
import CampaignUpdate from "@/components/Campaign/CampaignUpdate.vue";
import CampaignMembers from "@/components/Campaign/CampaignMembers.vue";
import CampaignReport from "@/components/Campaign/CampaignReport.vue";
import { set_default_pagination } from "./util";

export const campaign_routes: RouteRecordRaw = {
  path: "/campaign",
  children: [
    {
      path: "",
      component: CampaignList,
      name: "CampaignList",
      beforeEnter: set_default_pagination,
    },
    {
      path: ":campaign_id",
      component: CampaignDetail,
      name: "CampaignDetail",
      children: [
        {
          path: "dashboard",
          component: CampaignDashboard,
          name: "CampaignDashboard",
        },
        {
          path: "clients",
          component: CampaignClients,
          name: "CampaignClients",
          beforeEnter: set_default_pagination,
        },
        {
          path: "installers",
          component: CampaignInstallers,
          name: "CampaignInstallers",
          beforeEnter: set_default_pagination,
        },
        {
          path: "update",
          component: CampaignUpdate,
          name: "CampaignUpdate",
          beforeEnter: set_default_pagination,
        },
        {
          path: "members",
          component: CampaignMembers,
          name: "CampaignMembers",
        },
        {
          path: "report",
          component: CampaignReport,
          name: "CampaignReport",
        },
      ],
    },
  ],
};
